import './profile.card.scss'

interface ProfileCardProps {
    id: number
    title: string
    name: string
    position: string
    imageUrl: string
    buttonTitle: string
    setModalVisible: (id: number) => void
}

export const ProfileCard = (props: ProfileCardProps) => {
    return (
        <div className="profile-card">
            <h2 className="title-text-h1">{props.title}</h2>
            <div className="halas-profile-image" style={{ backgroundImage: `url(${props.imageUrl})` }} />
            <h2 className="title-text-h2">{props.name}</h2>
            <h3 className="title-text-h3">{props.position}</h3>
            <button className="button" onClick={() => props.setModalVisible(props.id)}>
                {props.buttonTitle}
            </button>
        </div>
    )
}
